import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { THEME_CONFIG } from './theme-config';

// API base URL from env (set at build time)
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';

const resources = {
  en: {
    translation: {},
  },
};

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: THEME_CONFIG.locale,
    lng: localStorage.getItem('i18nextLng') || THEME_CONFIG.locale,
    supportedLngs: ['en', 'ru', 'ar', 'fr'],
    ns: ['translation', 'errors'],
    defaultNS: 'translation',
    nsSeparator: false,
    detection: {
      // Order of lookup: localStorage → cookie → browser → fallback
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'locale',
    },
    interpolation: {
      // React already escapes by default
      escapeValue: false,
    },
    backend: {
      // Local fallback (offline / instant): /locales/{{lng}}/{{ns}}.json
      // The Admin app's public/ folder is served at /locales/...
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Override backend request to also try the API
      ajax: async (url, options, callback) => {
        try {
          // 1) Try local file first
          const localResp = await fetch(url);
          if (localResp.ok) {
            const data = await localResp.json();
            callback(null, { status: 200, data });
            return;
          }
        } catch (e) {
          // local not available, fall through to API
        }
        // 2) Fall back to backend API
        try {
          const apiUrl = `${API_BASE}/${API_VERSION}/rest/translations/paginate?lang=${(options && options.lng) || 'en'}`;
          const resp = await fetch(apiUrl, { credentials: 'include' });
          if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
          const data = await resp.json();
          const parsed = data && data.data && typeof data.data === 'object' ? data.data : {};
          callback(null, { status: 200, data: parsed });
        } catch (err) {
          callback(err, { status: 500, data: '' });
        }
      },
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
